export default document.documentElement.lang;



// WEBPACK FOOTER //
// ./public/scripts/webpack/language.js